"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  default: () => svp_access_default
});
module.exports = __toCommonJS(src_exports);

// src/get_accesses.ts
var import_api_client = require("@vgtv/api-client");

// src/access_mappings.ts
var accessMappings = {
  vgtv: {
    premium: {
      accessControl: "login",
      productIds: ["998"]
    },
    plus: {
      accessControl: "subscription",
      productIds: ["100023", "301784", "FEA-VG-PLUSARTICLES" /* VG_PLUS */, "301901"]
    },
    sport: {
      accessControl: "subscription",
      productIds: ["FEA-VG-ALLARTICLES", "FEA-VG-SPORT" /* VG_SPORT */, "301895"]
    },
    total: {
      accessControl: "subscription",
      productIds: ["FEA-VG-ADFREE" /* VG_TOTAL */]
    }
  },
  ab: {
    login: {
      accessControl: "login",
      productIds: ["998"]
    },
    plus: {
      accessControl: "subscription",
      productIds: ["10010", "FEA-AB-PLUSARTICLES" /* AFTONBLADET_PLUS */]
    }
  }
};
var access_mappings_default = accessMappings;

// src/helpers.ts
var getProductIdsByAccessControl = (provider, accessControl) => {
  return [
    ...new Set(
      Object.values(access_mappings_default[provider]).reduce((productIds, access) => {
        if (access.accessControl !== accessControl) {
          return productIds;
        }
        return [...productIds, ...access.productIds];
      }, [])
    )
  ];
};
var getLoginProductIds = (provider) => {
  return getProductIdsByAccessControl(provider, "login");
};
var getSubscriptionProductIds = (provider) => {
  return getProductIdsByAccessControl(provider, "subscription");
};
var mapProductIdsToAccesses = (provider, productIds) => {
  return Object.keys(access_mappings_default[provider]).filter((access) => {
    return access_mappings_default[provider][access].productIds.some(
      (productId) => productIds.includes(productId)
    );
  });
};

// src/ip_access.ts
var CHECK_IP_ACCESS_URL = "https://www.vg.no/check_ip_access";
var checkVgIpAccess = async () => {
  try {
    const response = await fetch(CHECK_IP_ACCESS_URL);
    return response.status === 200;
  } catch (_err) {
    return false;
  }
};

// src/memoize.ts
var memoizeNullary = (fn) => {
  if (fn.length > 0) {
    throw new Error("Invalid argument");
  }
  let called = false;
  let value;
  return () => {
    if (!called) {
      value = fn();
      called = true;
    }
    return value;
  };
};

// src/get_accesses.ts
var getSession = async (identity) => {
  try {
    const session = await identity.hasSession();
    return "error" in session ? null : session;
  } catch (err) {
    console.error(err);
    return null;
  }
};
var getAllowedFeatures = async ({
  identity,
  accessService,
  provider,
  env
}) => {
  var _a;
  const productIds = getSubscriptionProductIds(provider);
  if (env === "PRE") {
    return productIds;
  }
  const userId = await identity.getUserId();
  const session = await getSession(identity);
  if (!session) {
    return [];
  }
  const response = await accessService.hasAccess({
    productIds,
    userId: Number(userId),
    sp_id: session.sp_id
  });
  return (_a = response == null ? void 0 : response.allowedFeatures) != null ? _a : [];
};
var createClearAccessCache = ({
  getIdentityInstance,
  accessService,
  provider,
  env
}) => async () => {
  if (env === "PRE") {
    return;
  }
  const identity = await getIdentityInstance();
  const isLoggedIn = await identity.isLoggedIn();
  if (!isLoggedIn) {
    return;
  }
  const userId = await identity.getUserId();
  const productIds = getSubscriptionProductIds(provider);
  accessService.clearCachedAccessResult(productIds, Number(userId));
};
var createGetAccesses = ({
  getIdentityInstance,
  accessService,
  provider,
  env
}) => async () => {
  const identity = await getIdentityInstance();
  const isLoggedIn = await identity.isLoggedIn();
  if (!isLoggedIn) {
    return [];
  }
  const checkIPAllowlist = memoizeNullary(
    () => provider === import_api_client.Provider.VGTV ? checkVgIpAccess() : Promise.resolve(false)
  );
  const [allowedFeatures, hasVgIpAccess] = await Promise.all([
    getAllowedFeatures({
      identity,
      accessService,
      provider,
      env
    }),
    checkIPAllowlist()
  ]);
  const productIds = [
    ...allowedFeatures,
    ...getLoginProductIds(provider),
    hasVgIpAccess ? "FEA-VG-PLUSARTICLES" /* VG_PLUS */ : void 0
  ].filter((productId) => Boolean(productId));
  return mapProductIdsToAccesses(provider, productIds);
};

// src/location.ts
var import_api_client2 = require("@vgtv/api-client");
var CHECK_EEA_NO_ACCESS_URL = "https://amd-vgtv.akamaized.net/vgtv/geoblocked-eea/ping";
var CHECK_EEA_SE_ACCESS_URL = "https://amd-ab.akamaized.net/ab/geoblocked-eea/ping";
var CHECK_NO_ACCESS_URL = "https://amd-vgtv.akamaized.net/vgtv/geoblocked-norway/ping";
var CHECK_SE_ACCESS_URL = "https://amd-ab.akamaized.net/ab/geoblocked-sweden/ping";
var checkLocation = async (provider) => {
  const urls = [
    provider === import_api_client2.Provider.VGTV ? CHECK_EEA_NO_ACCESS_URL : CHECK_EEA_SE_ACCESS_URL,
    CHECK_NO_ACCESS_URL,
    CHECK_SE_ACCESS_URL
  ];
  try {
    const [eea, no, se] = await Promise.all(
      urls.map((url) => fetch(url).then((response) => response.status === 200))
    );
    return {
      // This request should respond with HTTP 200 status if accessed from any EEA country except provider-specific country
      eea,
      // This request should respond with HTTP 200 status if accessed from the provider-specific country
      local: provider === import_api_client2.Provider.VGTV ? no : se,
      se,
      no
    };
  } catch (_err) {
    return { eea: true, local: false, se: false, no: false };
  }
};

// src/cache.ts
var WebStorage = class {
  constructor(storage) {
    this.storage = storage;
  }
  get(key) {
    try {
      return this.storage.getItem(key);
    } catch (e) {
      return null;
    }
  }
  set(key, value) {
    try {
      this.storage.setItem(key, value);
    } catch (e) {
    }
  }
  delete(key) {
    try {
      this.storage.removeItem(key);
    } catch (e) {
    }
  }
};
var Cache = class {
  constructor() {
    this.storage = new WebStorage(window.sessionStorage);
  }
  get(key) {
    const raw = this.storage.get(key);
    const obj = raw ? JSON.parse(raw) : null;
    if (obj && Number.isInteger(obj.expiresOn) && obj.expiresOn > Date.now()) {
      return obj.value;
    }
    this.storage.delete(key);
    return null;
  }
  set(key, value, expiresIn = 0) {
    if (expiresIn <= 0) {
      return;
    }
    const expiresOn = Math.floor(Date.now() + expiresIn);
    this.storage.set(key, JSON.stringify({ expiresOn, value }));
  }
  delete(key) {
    this.storage.delete(key);
  }
};

// src/access_service.ts
var NAMESPACE = {
  PRE: "schibsted.com",
  PRO: "schibsted.com",
  PRO_NO: "spid.no"
};
var ENDPOINTS = {
  PRE: "https://access.pre.schibsted.digital",
  PRO: "https://access.aftonbladet.se",
  PRO_NO: "https://access.vg.no"
};
var AccessService = class {
  constructor(options) {
    this.cache = new Cache();
    this.env = options.env;
    this.authFlow = this.resolveAuthFlow();
  }
  isIdJwtFlowSupported() {
    const { hostname } = window.location;
    if (this.env === "PRO_NO") {
      return hostname.match(/^.+\.vg\.no$/) !== null;
    }
    if (this.env === "PRO") {
      return hostname.match(/^.+\.aftonbladet\.se$/) !== null;
    }
    return false;
  }
  resolveAuthFlow() {
    return this.isIdJwtFlowSupported() ? "IdJwtFlow" : "VarnishIdFlow";
  }
  async hasAccess({ productIds, userId, sp_id }) {
    const sortedIds = [...productIds].sort();
    const cacheKey = this.getAccessCacheKey(sortedIds, userId);
    let data = this.cache.get(cacheKey);
    if (!data) {
      data = await this.getAccess(sortedIds, sp_id);
      const expiresSeconds = 30;
      this.cache.set(cacheKey, data, expiresSeconds * 1e3);
    }
    if (!data.entitled) {
      return null;
    }
    return data;
  }
  clearCachedAccessResult(productIds, userId) {
    const sortedIds = [...productIds].sort();
    this.cache.delete(this.getAccessCacheKey(sortedIds, userId));
  }
  async getAccess(sortedIds, sp_id) {
    const url = new URL(`${ENDPOINTS[this.env]}/v1/access`);
    if (this.authFlow === "VarnishIdFlow") {
      url.searchParams.set("spid_instance", NAMESPACE[this.env]);
      url.searchParams.set("sp_id", sp_id);
    }
    url.searchParams.set("pids", sortedIds.join(","));
    url.searchParams.set("source", window.location.hostname);
    const response = await fetch(url, {
      cache: "no-store",
      credentials: this.authFlow === "IdJwtFlow" ? "include" : void 0
    });
    if (response.ok || response.status === 403) {
      return await response.json();
    }
    throw new Error(response.statusText);
  }
  getAccessCacheKey(sortedIds, userId) {
    return `prd_cbt_${sortedIds}_${userId}`;
  }
};

// src/svp_access.ts
var createSvpAccess = (options) => {
  const accessService = new AccessService(options);
  const getAccesses = createGetAccesses({
    getIdentityInstance: options.getIdentityInstance,
    accessService,
    provider: options.provider,
    env: options.env
  });
  const clearAccessCache = createClearAccessCache({
    getIdentityInstance: options.getIdentityInstance,
    accessService,
    provider: options.provider,
    env: options.env
  });
  return {
    getAccesses,
    clearAccessCache,
    checkLocation: memoizeNullary(() => checkLocation(options.provider))
  };
};
var svp_access_default = createSvpAccess;
